module.exports = __webpack_public_path__ + "img/1.29_Russian_road_sign.3da55c66.svg";